export default "__VITE_ASSET__D30ZjnD8__"